module.exports = __webpack_public_path__ + "static/media/services-bg.fc64ecf6.svg";